import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiAxios from "helpers/apiAxios";
import { handleAsyncThunkError } from "redux/reduxHelpers";

const baseUrl = (projectId) => `/crm/projects/${projectId}/proposal_submissions`;

export const getProposalSubmissions = createAsyncThunk(
  "ProposalSubmission/getProposalSubmissions",
  async ({ projectId }, { rejectWithValue }) => {
    try {
      // skipAccessDeniedPage: panel trong trang, không phải tài nguyên chính của
      // trang — 403 ở đây chỉ nên làm trống panel, không dựng màn hình 403 đè lên
      // cả project. Tab tự hiển thị trạng thái thiếu quyền.
      const res = await apiAxios.get(baseUrl(projectId), { skipAccessDeniedPage: true });
      return res.data.data;
    } catch (error) {
      return rejectWithValue(handleAsyncThunkError(error, "Failed to load submissions"));
    }
  }
);

export const createProposalSubmission = createAsyncThunk(
  "ProposalSubmission/createProposalSubmission",
  async ({ projectId, body, files = [], buildingIds = [] }, { rejectWithValue }) => {
    try {
      const fd = new FormData();
      if (body) fd.append("body", body);
      files.forEach(f => fd.append("attachments[]", f));
      buildingIds.forEach(id => fd.append("building_ids[]", id));
      const res = await apiAxios.post(baseUrl(projectId), fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data.data;
    } catch (error) {
      return rejectWithValue(handleAsyncThunkError(error, "Failed to create submission"));
    }
  }
);

export const deleteProposalSubmission = createAsyncThunk(
  "ProposalSubmission/deleteProposalSubmission",
  async ({ projectId, submissionId }, { rejectWithValue }) => {
    try {
      await apiAxios.delete(`${baseUrl(projectId)}/${submissionId}`);
      return { submissionId };
    } catch (error) {
      return rejectWithValue(handleAsyncThunkError(error, "Failed to delete submission"));
    }
  }
);

const proposalSubmissionSlice = createSlice({
  name: "crm_proposal_submission",
  initialState: { list: [], loading: false, sending: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProposalSubmissions.pending,   (state) => { state.loading = true; state.error = null; })
      .addCase(getProposalSubmissions.fulfilled, (state, { payload }) => { state.loading = false; state.list = payload; })
      .addCase(getProposalSubmissions.rejected,  (state, { payload }) => { state.loading = false; state.error = payload; })

      .addCase(createProposalSubmission.pending,   (state) => { state.sending = true; })
      .addCase(createProposalSubmission.fulfilled, (state, { payload }) => { state.sending = false; state.list = [payload, ...state.list]; })
      .addCase(createProposalSubmission.rejected,  (state, { payload }) => { state.sending = false; state.error = payload; })

      .addCase(deleteProposalSubmission.fulfilled, (state, { payload }) => {
        state.list = state.list.filter(s => s.id !== payload.submissionId);
      });
  },
});

export default proposalSubmissionSlice.reducer;
